import { FC } from 'react'
import { Container, ContainerLarge } from '../../container'
import { TimelineVideo } from '../video'
import { ReadMore } from '../../read-more'
import {
  TimelineTitle,
  TimelineTitleMask,
  TimelineIntro,
  TimelineSubtitle,
  TimelineContent,
  TimelineImage,
  TimelineAnchor,
} from '../styled'
import { texts } from '../../locale'
type Props = {
  scrollUp: boolean
}
export const Chapter_5: FC<Props> = ({ scrollUp }) => {
  return (
    <>
      <TimelineTitle>
        <TimelineAnchor id="chapter-5" $scrollUp={scrollUp} />
        <TimelineTitleMask />
        <img
          src={
            'https://gdb.rferl.org/02330000-0aff-0242-74e0-08da04becca1_w1920_r4.jpg'
          }
        />
        <h2>
          <span>5</span>
          Повзучий наступ Росії
          <strong>{texts.menu_10}</strong>
        </h2>
      </TimelineTitle>

      <ContainerLarge>
        <TimelineIntro>
          Після поразки у битві за столицю України Кремль переорієнтував свої
          зусилля на Донеччину і Луганщину, намагаючись дійти до
          адміністративних меж областей. У цей період Збройні сили України
          відчували серйозний брак боєприпасів – передусім, артилерійських – та
          майже не мали далекобійної зброї. Усі технічні прориви у військові
          допомозі – HIMARS, західні танки й системи ППО – були ще попереду; у
          травні Україна лише отримала перші зразки західних гаубиць. Поки ж
          українські військові стримували наступ агресора тим, що мали. У цей
          період війську довелося поволі відступати під потужними атаками з
          артилерійським вогнем, що за щільністю перевершував український у
          десятки разів. Проте, армії Путіна, попри поставлену задачу, не
          вдалося вийти на адміністративні межі регіону до кінця літа. Пізніше,
          як повідомить українська розвідка, він поставить аналогічну ціль
          військам на весну 2023-го. А згодом перенесе «дедлайни» знову. Тим
          часом, Сили оборони поступово насичувалися західними САУ і причіпними
          гарматами (М777, Caesar, FH17, PzH, Crab), й відсіч України Росії
          ставала дедалі ефективнішою.
        </TimelineIntro>

        <TimelineContent>
          <TimelineSubtitle>1 квітня</TimelineSubtitle>
          <p>Російські підрозділи захоплюють Ізюм на Харківщині.</p>
          <TimelineVideo id={'5FcK9NDgcac'} />

          <TimelineSubtitle>7 травня</TimelineSubtitle>
          <p>
            Після місяця штурмів окупаційні війська беруть Попасну в Луганській
            області. Це місто було настільки зруйноване в ході штурмів, що
            пізніше окупаційна адміністрація просто виключить його з переліку
            населених пунктів.
          </p>

          <TimelineSubtitle>8-13 травня</TimelineSubtitle>
          <p>
            У селі Білогорівка на Луганщині російські війська невдало
            намагаються форсувати головну водну артерію регіону – Сіверський
            Донець: їхні безповоротні втрати, за підрахунками ISW, склали до 500
            осіб особового складу і 80 одиниць техніки. На той момент це були чи
            не найбільші одномоментні втрати агресора у великій війні.
          </p>

          <TimelineSubtitle>12 травня</TimelineSubtitle>
          <p>Захоплене Рубіжне на Луганщині.</p>

          <TimelineSubtitle>16 травня</TimelineSubtitle>
          <p>
            РФ повністю окуповує Маріуполь. Останнім форпостом України у ньому
            став завод «Азовсталь». Захисники міста (полк «Азов», прикордонники,
            Донецька тероборона, 36 бригада морської піхоти, Нацгвардія) тримали
            оборону в оточеному заводі під ударами авіабомб більше місяця. Разом
            із військовими на «Азовсталі» переховувались і цивільні. Ось як
            виглядав бункер «Азовсталі» у ті дні:
          </p>
          <TimelineVideo id={'RFgwx4CJ43Y'} />

          <ReadMore>
            <p>
              Після тривалих переговорів про гуманітарний коридор, цивільних
              російські війська випустили із заводу. Усі вони проходили
              «фільтрацію» (перевірку на зв’язки з українськими захисниками), й
              ті, кому дозволили окупанти, виїхали на вільну територію України.
              Військові ж потрапити в полон, де частина перебуває і станом на
              лютий 2024 року. За даними Генштабу ЗСУ, утримуючи позиції на
              «Азовсталі», військові не дозволили противнику перекинути
              угруповання чисельністю до 17 батальйонних тактичних груп (близько
              20 тисяч особового складу) на інші напрямки. Розвідка Британії
              повідомляла, що українська оборона Маріуполя виснажила російські
              підрозділи та знизила їхню боєздатність.
            </p>
          </ReadMore>

          <TimelineSubtitle>13 квітня</TimelineSubtitle>
          <p>
            Поблизу острова Зміїний у Чорному морі Україна знищує флагман
            Чорноморського флоту крейсер «Москва». Він затонув, уражений двома
            крилатими ракетами берегового ракетного комплексу «Нептун».
          </p>

          <TimelineSubtitle>18 травня</TimelineSubtitle>
          <p>Захоплена Кремінна Луганської області.</p>

          <TimelineSubtitle>31 травня</TimelineSubtitle>
          <p>
            Окуповано Лиман Донецької області. Війська РФ намагаються пробитися
            до Слов’янська – одного з найбільших міст підконтрольної Україні
            частини Донеччини, «воріт» до адмінцентру області Краматорська.
          </p>

          <TimelineImage>
            <img
              src={
                'https://gdb.rferl.org/0ff60000-0aff-0242-0833-08da4b8d408a_w1000.jpg'
              }
            />
            <span>
              Військовий медик з пораненим під час евакуації, червень, район
              Світлодарська
            </span>
          </TimelineImage>

          <TimelineSubtitle>червень</TimelineSubtitle>
          <p>
            В середині місяця Росія захоплює Святогірськ, курортне місто на
            Сіверському Донці, а наприкінці – Сєвєродонецьк, адміністративний
            центр Луганської області. Також російські війська після 4-місячного
            штурму не змогли взяти і обійшли укріпрайон ЗСУ в містечках Гірське
            і Золоте на Луганщині, після чого захисники були змушені залишити
            їх. Щоразу, коли якесь місто переходило під контроль російської
            армії, воно було вже сильно поруйнованим, адже будинки просто
            розбивалися артилерією та авіацією РФ. Наприклад, у так виглядало
            Рубіжне, коли туди увійшла російська армія:
          </p>

          <TimelineImage>
            <img
              src={
                'https://gdb.rferl.org/01000000-0aff-0242-1832-08db132afd6e_w1000.jpg'
              }
            />
          </TimelineImage>

          <TimelineSubtitle>30 червня</TimelineSubtitle>
          <p>
            Українські війська звільняють острів Зміїний у Чорному морі. Його РФ
            захопила у перший день масштабного вторгнення за допомогою ракетного
            крейсера «Москва». Фраза українського моряка «Русский военный
            корабль, иди на **й», котра стала мемом, були сказана саме за тих
            обставин. Зміїний звільняли, як стало відомо пізніше, обстрілюючи
            його артилерією з берега та барж на морі. Ось як виглядав острів,
            коли на нього уперше потрапили журналісти:
          </p>
          <TimelineVideo id={'MlxaVVal2sU'} />

          <TimelineSubtitle>3 липня</TimelineSubtitle>
          <p>
            Росія вибиває українську армію з Лисичанська, останнього міста
            Луганської області. Відтоді вся вона, окрім кількох невеликих сіл
            уздовж самої фронту, – окупована.
          </p>
        </TimelineContent>
      </ContainerLarge>
    </>
  )
}
